<!-- Simplified Admin Shell -->
<header class="p-4 border-b flex items-center justify-between bg-surface shadow-sm">
  @if (header$ | async; as header) {
    <h1 class="text-xl font-semibold">{{ header.title }}</h1>
    <nav class="flex gap-4 text-sm">
      @for (link of header.links; track link.route) {
        <a mat-button [routerLink]="link.route" routerLinkActive="font-semibold" [routerLinkActiveOptions]="{ paths: 'exact', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' }">{{ link.label }}</a>
      } @empty {
        <a mat-button disabled>{{ header.navLabel }}</a>
      }
    </nav>
  }
</header>
<main class="p-6 bg-gray-50 min-h-screen">
  <router-outlet></router-outlet>
</main>

<!-- Global confirmation dialog host -->
<app-code-confirmation-host></app-code-confirmation-host>

<!-- Toast and Dialog -->
<p-toast position="top-right"></p-toast>
